import styled from '@emotion/styled'
import React from 'react'
import { breakpoint, calcRem } from '../../../../__styling'
import { ElectionNoteText } from '../../components/ElectionNoteText'
import { RaceLine44 } from '../../components/RaceLine44'

export interface TheRaceWinIndicatorProps {
    seatsToWin: number
    percentPerSeat: number
    offsetIndicator: boolean
}
export const TheRaceWinIndicator = ({
    seatsToWin,
    percentPerSeat,
    offsetIndicator,
}: TheRaceWinIndicatorProps) => {
    const toWinText = `${seatsToWin} to win`

    return (
        <TheRaceGraphWinGraphContainer offsetIndicator={offsetIndicator}>
            <TheRaceGraphWinIndicator
                percentFromRight={percentPerSeat * seatsToWin}
            >
                <ElectionNoteText>{toWinText}</ElectionNoteText>
                <RaceLine44 />
            </TheRaceGraphWinIndicator>
        </TheRaceGraphWinGraphContainer>
    )
}

const TheRaceGraphWinGraphContainer = styled('div')<{
    offsetIndicator?: boolean
}>(({ offsetIndicator = false }) => ({
    height: '100%',

    display: 'flex',
    position: 'absolute',
    top: 0,
    right: offsetIndicator ? '96px' : 0,

    // Mobile Styling
    width: offsetIndicator ? `calc(100% - 96px)` : '100%',

    // Desktop Styling
    // calcRem(125) width of StyledRaceElectionText
    // 96px width of TheRaceSwing + 16px gap
    [breakpoint('lg')]: {
        width: offsetIndicator
            ? `calc(100% - ${calcRem(125)} - 96px)`
            : `calc(100% - ${calcRem(125)})`,
    },
}))

const TheRaceGraphWinIndicator = styled('div')<{
    percentFromRight: number
}>(({ percentFromRight }) => ({
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'hidden',

    right: `${100 - percentFromRight}%`,
    transform: 'translateX(50%)',
    position: 'absolute',

    // Mobile styling
    height: '100%',

    // Bigger styling
    [breakpoint('lg')]: {
        height: `calc(100% + ${calcRem(16)})`,
        top: calcRem(-16),
    },
}))
